import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Eye, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-amber-500/30" data-id="element-18" data-mp="22fd6b9a2dywf">
      <div className="max-w-5xl mx-auto" data-id="element-19" data-mp="22dissg14h92d">
        <div className="text-center mb-16" data-id="element-20" data-mp="1ydrwxxwqo2qz">
          <p className="text-blue-700 font-bold tracking-widest uppercase mb-2" data-id="element-21" data-mp="1yetcofop9df1">
            Included with your purchase at no additional cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-blue-950" data-id="element-22" data-mp="15q5l62dcxrt1">
            🎁 <span className="text-amber-600" data-id="element-23" data-mp="1jhaopfjuj48n">5 Professional Visual Bonus Guides</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-24" data-mp="1epsoitpnd7oq">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-amber-500/40 rounded-2xl p-8 shadow-sm shadow-blue-700/10 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-25" data-mp="qzolooka9bys" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-blue-950 text-amber-500 px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-26" data-mp="2ofxv6uyh3to9">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-slate-50 border border-amber-500/40 rounded-full flex items-center justify-center text-amber-500 mb-4" data-id="element-27" data-mp="1vrijoiejvtho">
                <Gift size={24} data-id="element-28" data-mp="20thmnr6dooe3" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-28 text-blue-950" data-id="element-29" data-mp="25qrj3qs6q0bf">{bonus.title}</h3>
              <p className="text-blue-700 text-sm italic mb-4 border-l-2 border-amber-500 pl-4" data-id="element-30" data-mp="3c5ifbh6d4wz4">
                {bonus.subtitle}
              </p>
              {bonus.intro.map(paragraph => <p key={paragraph} className="text-slate-700 text-sm mb-3 leading-relaxed" data-id="element-31" data-mp="1h2lzz0gjj5tb">
                  {paragraph}
                </p>)}
              {bonus.chain && <p className="text-blue-700 font-bold text-sm bg-slate-50 border border-blue-700/20 rounded-lg px-3 py-2 uppercase mb-4" data-id="element-32" data-mp="1q4d6g7iwngo8">
                  {bonus.chain}
                </p>}
              <p className="text-blue-950 font-semibold text-sm mb-3 mt-1" data-id="element-33" data-mp="yc49l2j6kmb4">{bonus.bulletsLabel}</p>
              <ul className={`mb-6 ${bonus.bullets.length > 10 ? `grid sm:grid-cols-2 ${index === 4 ? 'md:grid-cols-3' : ''} gap-x-4 gap-y-2` : 'space-y-2'}`} data-id="element-34" data-mp="tem45m4dgp7v">
                {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-35" data-mp="enlr13sok75e">
                    <CheckCircle2 size={16} className="text-amber-500 shrink-0 mt-0.5" data-id="element-36" data-mp="ao4n4eswji2c" />
                    <span className="text-slate-700 text-sm" data-id="element-37" data-mp="iuykewwl1dr">{bullet}</span>
                  </li>)}
              </ul>
              {bonus.extraList && <div className="mb-6" data-id="element-38" data-mp="5bxw0y4swuz8">
                  <p className="text-blue-950 font-semibold text-sm mb-3" data-id="element-39" data-mp="3mre313qbpruk">{bonus.extraList.label}</p>
                  <ul className="flex flex-wrap gap-2" data-id="element-40" data-mp="3rowg96bdit8d">
                    {bonus.extraList.items.map(item => <li key={item} className="text-[11px] font-bold uppercase tracking-wide px-2.5 py-1 rounded-md bg-slate-50 text-blue-950 border border-blue-700/20" data-id="element-41" data-mp="jb79vr5jbd01">
                        {item}
                      </li>)}
                  </ul>
                </div>}
              <div className="flex items-start gap-2.5 bg-slate-50 border border-amber-500/40 rounded-xl p-4 mb-6 flex-grow" data-id="element-42" data-mp="2u1nv5cfabm6w">
                <Eye size={16} className="text-blue-700 shrink-0 mt-0.5" data-id="element-43" data-mp="2z2lcjmsh0c7c" />
                <p className="text-slate-700 text-sm leading-relaxed" data-id="element-44" data-mp="3f983k8njq2hm">
                  <span className="text-blue-950 font-bold" data-id="element-45" data-mp="3ahq11g5vjtuj">Visual value: </span>
                  {bonus.visualValue}
                </p>
              </div>
              <p className="text-blue-950 font-bold text-sm uppercase tracking-wide mt-auto pt-4 border-t border-amber-500/30" data-id="element-46" data-mp="35imwrxxpxrnm">
                {bonus.closing}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}